var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import { ChevronDown, Download } from 'lucide-react';
import CustomButton from '../buttonComponent/CustomButton';
import { baseColors } from '../../Themes/colors';
import { EXPORT_FORMAT_OPTIONS } from '../../utils/exportTable';
var LucideIconSlot = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { component: "span", sx: { display: 'inline-flex', '& path': { fill: 'none !important' } } }, children));
};
var ExportMenuButton = function (_a) {
    var onExport = _a.onExport, summary = _a.summary, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.formats, formats = _c === void 0 ? EXPORT_FORMAT_OPTIONS : _c;
    var _d = useState(null), anchor = _d[0], setAnchor = _d[1];
    var _e = useState(false), isExporting = _e[0], setIsExporting = _e[1];
    var handleSelect = function (format) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setAnchor(null);
                    setIsExporting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4, onExport(format)];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    setIsExporting(false);
                    return [7];
                case 4: return [2];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(CustomButton, { MDButton: true, variant: "outlined", startIcon: React.createElement(LucideIconSlot, null,
                React.createElement(Download, { size: 16 })), endIcon: React.createElement(LucideIconSlot, null,
                React.createElement(ChevronDown, { size: 16 })), onClick: function (event) { return setAnchor(event.currentTarget); }, disabled: isExporting, fullWidth: false, iconSize: 18, sx: { flexShrink: 0 }, "aria-haspopup": "menu", "aria-expanded": Boolean(anchor) }, isExporting ? 'Exporting…' : 'Export'),
        React.createElement(Menu, { anchorEl: anchor, open: Boolean(anchor), onClose: function () { return setAnchor(null); }, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, PaperProps: { sx: { mt: 0.75, minWidth: 280, maxWidth: 320, borderRadius: '10px', boxShadow: '0 8px 24px rgba(0,0,0,0.12)' } } },
            summary && (React.createElement(Box, { sx: { px: 2, pt: 1, pb: 1.25 } },
                React.createElement(Typography, { variant: "body2", sx: { color: baseColors.greyPreset[5], lineHeight: 1.4 } }, summary))),
            formats.map(function (_a) {
                var format = _a.format, label = _a.label;
                return (React.createElement(MenuItem, { key: format, onClick: function () { return handleSelect(format); }, disabled: disabled, sx: { fontSize: 14, py: 1 } }, label));
            }))));
};
export default ExportMenuButton;
